import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import classNames from 'classnames';
import { Button, CircularProgress } from '@material-ui/core';
import './../Account/Login.css';
import CustomAlert from './CustomAlert';
import { Helmet } from 'react-helmet';

function BookingUserInfo({createOrderRequest, isPayemntLoading}) {
    const { register, handleSubmit, reset, errors } = useForm();
    const [openNotify, setOpenNotify] = React.useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');



    const onSubmit = async (data) => {
        try {
            createOrderRequest(data);
        } catch (error) {
            console.log("ERROR ==> ", error)
            setNotificationMessage('Something went wrong, Please try again!');
            setOpenNotify(true);
            setAlertType('error');
        }
    };

    return (
        <>
            <div className="login">
                <Helmet>
                    <meta name="description" content="To login yourseld to use this website..." />
                    <title>Retailer Login | Kaipsool Pharmatech</title>
                </Helmet>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                        <div className="col-md-12 mb-3">
                            <div className="form-group">
                                <label className="login__textboxLabel">Name <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span></label>
                                <input type="text" className={classNames("form-control login__textbox", { "is-invalid": errors.name })}
                                    name="name" placeholder="Name" autoComplete="off"
                                    ref={register({ required: 'Please enter your name!' })} />
                                <small className="form-text text-danger">{errors.name && errors.name.message}</small>
                            </div>
                        </div>
                        <div className="col-md-12 mb-3">
                            <div className="form-group">
                                <label className="login__textboxLabel">Mobile Number <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span></label>
                                <input type="number" className={classNames("form-control login__textbox", { "is-invalid": errors.phone })}
                                    name="phone" placeholder="Phone Number" autoComplete="off"
                                    ref={register({ required: 'Please enter your phone number!' })} />
                                <small className="form-text text-danger">{errors.phone && errors.phone.message}</small>
                            </div>
                        </div>
                        <div className="col-md-12 mb-3">
                            <div className="form-group">
                                <label className="login__textboxLabel">Email Address <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span></label>
                                <input type="email" className={classNames("form-control login__textbox", { "is-invalid": errors.email })}
                                    name="email" placeholder="Email Address" autoComplete="off"
                                    ref={register({ required: 'Please enter your email address!' })} />
                                <small className="form-text text-danger">{errors.email && errors.email.message}</small>
                            </div>
                        </div>
                        <div className="col-sm-12 text-center mt-2">
                            <div className="d-flex justify-content-center">
                                <div className="p-2">
                                    <Button type="submit" variant="contained" color="primary" size="small"
                                        className="login__btn">
                                        {isPayemntLoading ? <CircularProgress size={18} /> : 'Pay Now'}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType || 'error'}
                notificationMessage={notificationMessage} />
        </>
    )
}

export default BookingUserInfo
